import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _dec2, _dec3, _obj;
import EmberObject from "@ember/object";
import Mixin from "@ember/object/mixin";
import { isEmpty } from "@ember/utils";
import discourseComputed from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
export default Mixin.create((_dec = discourseComputed("passwordMinLength"), _dec2 = discourseComputed("isDeveloper", "admin"), _dec3 = discourseComputed("accountPassword", "passwordRequired", "rejectedPasswords.[]", "accountUsername", "accountEmail", "passwordMinLength", "forceValidationReason"), (_obj = {
  rejectedPasswords: null,
  init() {
    this._super(...arguments);
    this.set("rejectedPasswords", []);
    this.set("rejectedPasswordsMessages", new Map());
  },
  passwordInstructions() {
    return I18n.t("user.password.instructions", {
      count: this.passwordMinLength
    });
  },
  passwordMinLength(isDeveloper, admin) {
    return isDeveloper || admin ? this.siteSettings.min_admin_password_length : this.siteSettings.min_password_length;
  },
  passwordValidation(password, passwordRequired, rejectedPasswords, accountUsername, accountEmail, passwordMinLength, forceValidationReason) {
    const failedAttrs = {
      failed: true,
      ok: false,
      element: document.querySelector("#new-account-password")
    };
    if (!passwordRequired) {
      return EmberObject.create({
        ok: true
      });
    }
    if (rejectedPasswords.includes(password)) {
      return EmberObject.create(Object.assign(failedAttrs, {
        reason: this.rejectedPasswordsMessages.get(password) || I18n.t("user.password.common")
      }));
    }

    // If blank, fail without a reason
    if (isEmpty(password)) {
      return EmberObject.create(Object.assign(failedAttrs, {
        message: I18n.t("user.password.required"),
        reason: forceValidationReason ? I18n.t("user.password.required") : null
      }));
    }

    // If too short
    if (password.length < passwordMinLength) {
      return EmberObject.create(Object.assign(failedAttrs, {
        reason: I18n.t("user.password.too_short")
      }));
    }
    if (!isEmpty(accountUsername) && password === accountUsername) {
      return EmberObject.create(Object.assign(failedAttrs, {
        reason: I18n.t("user.password.same_as_username")
      }));
    }
    if (!isEmpty(accountEmail) && password === accountEmail) {
      return EmberObject.create(Object.assign(failedAttrs, {
        reason: I18n.t("user.password.same_as_email")
      }));
    }

    // Looks good!
    return EmberObject.create({
      ok: true,
      reason: I18n.t("user.password.ok")
    });
  }
}, (_applyDecoratedDescriptor(_obj, "passwordInstructions", [_dec], Object.getOwnPropertyDescriptor(_obj, "passwordInstructions"), _obj), _applyDecoratedDescriptor(_obj, "passwordMinLength", [_dec2], Object.getOwnPropertyDescriptor(_obj, "passwordMinLength"), _obj), _applyDecoratedDescriptor(_obj, "passwordValidation", [_dec3], Object.getOwnPropertyDescriptor(_obj, "passwordValidation"), _obj)), _obj)));